import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
  DEFAULT_MEDIA_BREAKPOINTS,
  NbLayoutDirection,
  NbTooltipModule,
  NbToggleModule,
} from "@nebular/theme";

import { FooterComponent, HeaderComponent } from "./components";
import { CapitalizePipe, IqPipe } from "./pipes";
import { OneColumnLayoutComponent } from "./layouts";
import { DEFAULT_THEME } from "./styles/theme.default";
import { COSMIC_THEME } from "./styles/theme.cosmic";
import { CORPORATE_THEME } from "./styles/theme.corporate";
import { DARK_THEME } from "./styles/theme.dark";
import { CogSettingsComponent } from "./components/cog-settings/cog-settings.component";
import { DollarPipe } from "./pipes/dollar.pipe";
import { ExchangeDollarToIQDPipe } from "./pipes/exchange-dollar-to-iqd.pipe";
import { ExchangeIQDToDollarPipe } from "./pipes/exchange-iqdto-dollar.pipe";
import { ExchangeBackwards } from "./pipes/exchange-backward.pipe";

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbToggleModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbTooltipModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  OneColumnLayoutComponent,
  CogSettingsComponent,
];

const PIPES = [
  CapitalizePipe,
  IqPipe,
  DollarPipe,
  ExchangeDollarToIQDPipe,
  ExchangeBackwards,
  ExchangeIQDToDollarPipe,
];
@NgModule({
  imports: [CommonModule, ...NB_MODULES],
  exports: [CommonModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: "orange-theme",
          },
          [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME],
          DEFAULT_MEDIA_BREAKPOINTS,
          NbLayoutDirection.RTL
        ).providers,
      ],
    };
  }
}
